<div class="flex items-start space-x-6"><slot></slot></div>